import axios from 'axios';
import jwtEncode from 'jwt-encode';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5070/api',
    timeout: 5000,
});

// Add a request interceptor to generate the JWT token locally
api.interceptors.request.use(
    (config) => {
        const secret = process.env.REACT_APP_API_JWT_SECRET;

        let payload = { id: 0, email: 'system@neuroupdate', role: 'user' };
        try {
            const userStr = localStorage.getItem('user');
            if (userStr) {
                const user = JSON.parse(userStr);
                payload = { id: user.id, email: user.email, role: user.role };
            }
        } catch (e) {
            console.error('Error parsing local user', e);
        }

        if (secret) {
            const token = jwtEncode(payload, secret);
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            console.warn("REACT_APP_API_JWT_SECRET not configured. API requests may fail.");
            // Fallback for transition
            const oldToken = localStorage.getItem('token');
            if (oldToken) config.headers.Authorization = `Bearer ${oldToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
